// extracted by mini-css-extract-plugin
module.exports = {"closedMonthPopup":"jaPsy","closed":"WSbRb","text":"dzK3+"};